import colors from 'assets/theme/base/colors';
import React from 'react';

interface RedCircleBadgeProps {
  number?: number;
  size?: number;
}

const RedCircleBadge: React.FC<RedCircleBadgeProps> = ({ number = 1, size = 24 }) => {
  const circleStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: colors.error.main,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: size * 0.6,
    fontWeight: 'bold',
  };

  return <div style={circleStyle}>{number}</div>;
};

export default RedCircleBadge;
